import { ElementNode, $applyNodeReplacement } from 'lexical';

export class ColumnNode extends ElementNode {
  static getType() {
    return 'column';
  }

  static clone(node) {
    return new ColumnNode(node.__key);
  }

  constructor(key) {
    super(key);
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = 'column-item';
    return dom;
  }

  updateDOM() {
    return false;
  }

  static importJSON(serializedNode) {
    const node = $createColumnNode();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'column',
      version: 1,
    };
  }

  canBeEmpty() {
    return false;
  }

  isInline() {
    return false;
  }

  collapseAtStart() {
    return true;
  }
}

export function $createColumnNode() {
  return $applyNodeReplacement(new ColumnNode());
}

export function $isColumnNode(node) {
  return node instanceof ColumnNode;
}
